module.exports = __webpack_public_path__ + "static/img/PLM.80036c77.svg";